import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

if (document.getElementById('vue-trainings')) {
    new Vue({
        el: '#vue-trainings',
        propsData: { ...document.getElementById("vue-trainings").dataset },
        props: {
            lang: {
                type: String,
                default: '',
            },
            initialLength: {
                type: String,
                default: '',
            },
            content: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                departements_categories: [],
                isRemote: false,
                searchQuery: '',
                apiUrl: `${location.origin}/wp-json/wp/v2/trainings/`,
                loading: false,
                items: [],
                totalPages: null,
                showingFullText: false,
                filters: {
                    page: 1,
                    per_page: 9,
                    lang: this.lang,
                },}
        },
        mounted() {
            this.getItems()
            this.getDepartements()
        },
        filters: {
            date(value) {
                return moment(value).format('D MMMM YYYY')
            }
        },
        computed: {
            hasMore() {
                return this.totalPages > this.filters.page + 1;
            },
            toggleLabel(){
                return this.showingFullText ? "Fermer" : "Lire plus"
            },
            formattedBody() {
                if (this.showingFullText) {
                    return this.content;
                }

                return `${this.content.slice(0, Number(this.initialLength)).trim()}...`;
            }
        },
        methods: {
            deleteEmptyCategories(cat) {
                return cat.filter((el) => el.count != 0)
            },
            getDepartements() {
                axios.request({
                    method: 'GET',
                    url: "/wp-json/wp/v2/departements_categories",
                    params: {
                        per_page: 99
                    }
                }).then(response => {
                    this.departements_categories = this.deleteEmptyCategories(response.data)
                })
            },
            updateFilterByCheckbox(id) {
                if (this.isRemote) {
                    Vue.set(this.filters, 'departements_categories', [id])
                    this.getItems();
                } else {
                    this.updateFilter('departements_categories', 0)
                }
            },
            loadMore() {
                this.showingFullText = !this.showingFullText
            },
            getItems(more=false) {
                this.loading = true
                axios.get(this.apiUrl,
                    { params: this.filters})
                    .then(({ data, headers }) => {
                        this.items = more ? [...this.items, ...data] : data;
                        this.loading = false;
                        this.totalPages = headers['x-wp-totalpages']
                    })
            },
            getMore() {
                // Vue.set(this.filters, 'page', this.filters.page + 1);
                this.filters.page++;
                this.getItems(true)
            },
            updateSearch(e){
                Vue.set(this.filters, 'search', this.searchQuery);
                this.getItems();
            },
            updateFilter(filter, value) {
                value === 0
                    ? Vue.delete(this.filters, filter)
                    : Vue.set(this.filters, filter, value)
                this.getItems();
            },
            resetSearch() {
                this.searchQuery = ''
                Vue.delete(this.filters, 'search')
                this.getItems();
            },
            resetFilters() {
                this.searchQuery = ''
                this.filters = {
                    page: 1,
                    per_page: 9,
                    lang: this.lang,
                }
                this.getItems();
            }
        }
    })
}
